import { connect } from 'react-redux';

import WalletGate from './WalletGate';
import { isLocked, isNotProvided, isMissingWeb3 } from '../selectors/account';
import { accountWalletReset, accountWalletSelect } from '../actions/account';
import { ACCOUNT_REFRESHING } from '../actionTypes';
import isStateLoading from '../utilities/isStateLoading';

const mapStateToProps = (state, ownProps) => {
  const { loadingSelectors } = ownProps;
  return {
    currentAddress: state.account.address,
    detectedNetwork: state.account.network,
    expectedNetwork: state.app.expectedNetwork,
    wrongNetwork: !!(state.account.network && state.account.network !== state.app.expectedNetwork),
    isLoading: isStateLoading(loadingSelectors, state),
    isLocked: isLocked(state),
    isMissingWeb3: isMissingWeb3(state),
    isNotProvided: isNotProvided(state),
    walletType: state.account.walletType,
    supportedWallets: state.app.supportedWallets,
  };
};

const mapDispatchToProps = dispatch => ({
  resetWallet: () => dispatch(accountWalletReset()),
  selectWallet: (walletType, walletOptions) => {
    dispatch(accountWalletSelect(walletType, walletOptions));
  },
  refreshAccount: () =>
    dispatch({
      type: ACCOUNT_REFRESHING,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(WalletGate);



// WEBPACK FOOTER //
// ./src/components/WalletGateContainer.js